module.exports = __webpack_public_path__ + "img/地图C-时尚之都购物与美食.f938bf0e.png";